import React, { forwardRef } from 'react';
import clsx from 'clsx';
import { IPanelBodyProps } from './panel-body';

/* eslint-disable-next-line */
export interface IPanelHeaderProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {}

export const PanelHeader: React.FC<IPanelHeaderProps> = forwardRef<HTMLDivElement, IPanelBodyProps>(
    (props, ref): JSX.Element => {
        const {
            className,
            ...rest
        } = props;

        return (
            <div
                ref={ref}
                className={clsx('oms-panel__header', className)}
                {...rest}
            />
        );
    }
);
